module.exports = __webpack_public_path__ + "static/b88676494c28a2631132c8eba8a2e967.svg";